import type { OrganizationPayload } from '@Application/Organizations/Organizations/Actions/organizationsFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class OrganizationView {
	readonly id: number;
	readonly name: string;
	readonly siret: string | null;
	readonly headOfficeAddress: string | null;
	readonly documentFooterMentions: string | null;

	constructor(payload: OrganizationPayload) {
		this.id = payload.id;
		this.name = payload.name;
		this.siret = payload.siret;
		this.headOfficeAddress = payload.headOfficeAddress;
		this.documentFooterMentions = payload.documentFooterMentions;

		Object.freeze(this);
	}
}

export default OrganizationView;
